import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROMO_CODE_FEATURE_KEY,
  PromoCodeState,
  promoCodeAdapter,
} from './promo-code.reducer';

// Lookup the 'PromoCode' feature state managed by NgRx
export const getPromoCodeState = createFeatureSelector<PromoCodeState>(
  PROMO_CODE_FEATURE_KEY,
);

const { selectAll, selectEntities } = promoCodeAdapter.getSelectors();

export const getPromoCodeLoaded = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => state.loaded,
);

export const getTotalPromoCodes = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => state.total,
);

export const getPromoCodeLoading = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => state.loading,
);

export const getPromoCodeError = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => state.error,
);

export const getAllPromoCode = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => selectAll(state),
);

export const getPromoCodeEntities = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getPromoCodeState,
  (state: PromoCodeState) => state.selectedId,
);

export const getSelected = createSelector(
  getPromoCodeEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);
